import React from 'react';

const GlassPanel = ({ children, className = '', style = {} }) => {
  return (
    <div 
      className={`glass ${className}`} 
      style={{ 
        padding: '1.5rem', 
        marginBottom: '1rem',
        width: '100%',
        ...style 
      }}
    >
      {children}
    </div>
  );
};

export default GlassPanel;
